// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"support-hero_wrapper__u_pIW","image-overlay":"support-hero_image-overlay__EGqVw"};